import ShowNewsButton from "./ShowNewsButton"
import Stepper from "../Stepper"
import Thumbnail from "../Thumbnail/Thumbnail"
import { strings as Localization } from "../../lib/Localization"
import { useLanguage } from "../../lib/hooks/languageHooks"
import { useGetNewsQuery } from "../../redux/services/broditWebApi"
import { removeTrailingSlash } from "../../lib/helper/commonHelper"
import theme from "../../theme"
import { mobileBreakpoint, tabletBreakpoint } from "../../lib/helper/viewportHelper"
import { useProxyPath } from "../../redux/hook/settingsHooks"
import { Redirect, useHistory, useRouteMatch } from "react-router-dom"

import { Skeleton } from "@material-ui/lab"
import { Box, useMediaQuery } from "@material-ui/core"
import React, { useEffect, useState } from "react"

function DeviceNewsStepper() {
    const [index] = useState(0)
    const [redirect, setRedirect] = useState(false)
    const history = useHistory()
    const proxyPath = useProxyPath()
    const language = useLanguage()
    const isSmall = useMediaQuery(theme.breakpoints.down(tabletBreakpoint))
    const isMobile = useMediaQuery(theme.breakpoints.down(mobileBreakpoint + 200))

    let limit
    if (isMobile) {
        limit = 1
    } else if (isSmall) {
        limit = 2
    } else {
        limit = 4
    }

    const { data: newsArticles, isFetching } = useGetNewsQuery({
        language,
        limit: limit,
        groups: ["device"]
    })
    const { url } = useRouteMatch()

    useEffect(() => () => {
        setRedirect(false)
    })

    return (
        <Box id="deviceNewsStepper">
            {redirect && <Redirect to={`${removeTrailingSlash(url)}/news`} />}
            <Stepper
                style={{
                    margin: 45
                }}
                pages={
                    [
                        <Box
                            key="-"
                            id="deviceNewsStepperList"
                            style={{
                                display: "flex"
                            }}
                            spacing={5}
                        >
                            {
                                !isFetching && newsArticles
                                && newsArticles.map(news => (
                                    <Thumbnail
                                        key={news.id}
                                        thumbNailId={news.id.replace("\\", "-")}
                                        style={{ marginRight: 45, flexGrow: 1 }}
                                        href={`/news/${news.originalId}`}
                                        src={news.images?.[0]}
                                        alt={`${Localization.news} ${news.originalId}`}
                                        srcWidth="310"
                                    />
                                ))
                            }
                            {
                                isFetching
                                && [...Array(limit).keys()].map(i => (
                                    <Skeleton
                                        key={i}
                                        style={{ marginRight: 45, flexGrow: 1, height: 100 }}
                                    />
                                ))
                            }
                        </Box>
                    ]
                }
                index={index}
                setIndex={() => { }}
                nextButtonComponent={ShowNewsButton}
                backButtonComponent={() => null}
                handleNext={() => { history.push(`${proxyPath}/${language}`); setRedirect(true) }}
                disabledSwipe
            />
        </Box>
    )
}

export default DeviceNewsStepper
